/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ExchangeRateData from './ExchangeRateData';
import MaterialProperty from './MaterialProperty';
import PerplayStatisticsControllerDtoTokenStatisticsTokenData from './PerplayStatisticsControllerDtoTokenStatisticsTokenData';
import PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData from './PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData';

/**
 * The PerplayStatisticsControllerDtoTokenResponse model module.
 * @module model/PerplayStatisticsControllerDtoTokenResponse
 * @version 1.0
 */
class PerplayStatisticsControllerDtoTokenResponse {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoTokenResponse</code>.
     * @alias module:model/PerplayStatisticsControllerDtoTokenResponse
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoTokenResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoTokenResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoTokenResponse} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoTokenResponse} The populated <code>PerplayStatisticsControllerDtoTokenResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoTokenResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('tokenData')) {
                obj['tokenData'] = ApiClient.convertToType(data['tokenData'], [PerplayStatisticsControllerDtoTokenStatisticsTokenData]);
            }
            if (data.hasOwnProperty('exchangeRateData')) {
                obj['exchangeRateData'] = ApiClient.convertToType(data['exchangeRateData'], [ExchangeRateData]);
            }
            if (data.hasOwnProperty('graphData')) {
                obj['graphData'] = ApiClient.convertToType(data['graphData'], [PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoTokenResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoTokenResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        if (data['tokenData']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['tokenData'])) {
                throw new Error("Expected the field `tokenData` to be an array in the JSON data but got " + data['tokenData']);
            }
            // validate the optional field `tokenData` (array)
            for (const item of data['tokenData']) {
                PerplayStatisticsControllerDtoTokenStatisticsTokenData.validateJSON(item);
            };
        }
        if (data['exchangeRateData']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['exchangeRateData'])) {
                throw new Error("Expected the field `exchangeRateData` to be an array in the JSON data but got " + data['exchangeRateData']);
            }
            // validate the optional field `exchangeRateData` (array)
            for (const item of data['exchangeRateData']) {
                ExchangeRateData.validateJSON(item);
            };
        }
        if (data['graphData']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['graphData'])) {
                throw new Error("Expected the field `graphData` to be an array in the JSON data but got " + data['graphData']);
            }
            // validate the optional field `graphData` (array)
            for (const item of data['graphData']) {
                PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Array.<module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenData>} tokenData
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['tokenData'] = undefined;

/**
 * @member {Array.<module:model/ExchangeRateData>} exchangeRateData
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['exchangeRateData'] = undefined;

/**
 * @member {Array.<module:model/PerplayStatisticsControllerDtoTokenStatisticsTokenGraphData>} graphData
 */
PerplayStatisticsControllerDtoTokenResponse.prototype['graphData'] = undefined;






export default PerplayStatisticsControllerDtoTokenResponse;

